module.exports = __webpack_public_path__ + "img/DealerIcons-Twitter-Off.a56dd15.jpg";